// @flow

import * as React from 'react';

import { InteractionLogger } from '@ta/tracking.interactions';
import { LinkPreview } from '@ta/social.link-preview';

import MatchingItemsMemberContent from './MatchingItemsMemberContent';
import styles from './ShelfLinkPostSection.less';

type Props = {
  /** The json link post object */
  post: any,
  isSponsored?: boolean,
};

const ShelfLinkPostSection = ({ post, isSponsored }: Props) => {
  if (!post) {
    return null;
  }
  const linkPreview = {
    id: post.preview.id,
    title: post.preview.title,
    description: post.preview.description,
    url: post.preview.canonicalUrl,
    urlDomain: post.preview.urlDomain,
    imgSource:
      post.preview.media && post.preview.media[0] ? post.preview.media[0].photoSizes : undefined,
  };

  return (
    <div className={`ui_card ${styles.link_post_container}`}>
      <InteractionLogger>
        {logInteraction => (
          <React.Fragment>
            <LinkPreview
              linkPreviewState={linkPreview}
              isClickable
              onClick={e => logInteraction(e, 'feedClick')}
              border={false}
              matchingShelfItem
            />
            <MatchingItemsMemberContent userProfile={post.userProfile} isSponsored={isSponsored} />
          </React.Fragment>
        )}
      </InteractionLogger>
    </div>
  );
};

export default ShelfLinkPostSection;
